import React, { useState, useContext, useEffect } from 'react'

import { CartContext } from '../../context/cart'
import { ComponentContext } from '../../context/component'
import api from '../../services/api'
import checkIcon from '../../images/Svg/checkComponent.svg'
import trashIcon from '../../images/Svg/trashIcon.svg'
import addIconContent from "../../images/Svg/addIconContent.svg"

var lz = require('lz-string');

const SearchSubComponent = ({ name, id, price, develop_time, icon, category, description }) => {
  const { addItemToCart, removeItemCart, updateCart, selectUserItens, updateComponent } = useContext(CartContext)
  const {loadImage} = useContext(ComponentContext)
  const [cartItems, setCartItems] = useState([])

  const [showComponent, setShowComponent] = useState(false)
  const [imageDecompress, setImageDecompress] = useState()
  const [select, setSelect] = useState(false)
  const urlParams = new URLSearchParams(window.location.search);
  const id_info = urlParams.get("id")

  const onAddedFeature = (idItem,category,name,description) => {

    if (select == false) {
       addItemToCart(idItem,category,name,description,id_info)
       setSelect(true)

    } else {
        removeItemCart(idItem,id_info)
        setSelect(false)
    }

  }

  const getItemsChecked = (id) => {
    localStorage.setItem("@LAST_CHECK_SEARCH",id)

  }

  const getItemsInCart = async () => {



    const response = await api.post("cart/simple/user", {

        "mail": localStorage.getItem("@MAIL"),
        "id": id_info,
    })

    if (response.status != 200) {

        return false

    }

    if (response.status == 200) {

        setCartItems(response.data)

        localStorage.setItem("@TOTAL_FEATURES", response.data.length)


    }


}



function showImage(idImage){

  loadImage(idImage,description,price)
}

  useEffect(() => {

    getItemsInCart()

  },[])

  useEffect(() => {

    const image = lz.decompressFromUTF16(icon)

    setImageDecompress(image)

  }, [icon])
  useEffect(() => {

    cartItems.map(item => {
        if (item.componentSelect == id) {
            setSelect(true)
        }
    })


}, [cartItems])

useEffect(() => {
  getItemsInCart()
}, [updateCart])
  
  return (

    <div id={id}>
      

      <div class="card card-body" style={{ background: "#F9F9FA", borderRadius: "0px", height: "auto", border: "none", borderBottom: "1px solid #D7D7D7" }}>

        <div style={{ display: "flex", alignItems: 'center', justifyContent: "space-between" }}>

        {showComponent == true && localStorage.getItem("@LAST_CHECK_SEARCH") == id

            ?
            <div className="borderLeftSubFunctionalitie"></div>

            :
            <></>

          }
          
          <img style={{ width: "21px", height: "21px" }} src={select ? checkIcon : "data:image/png;base64," + imageDecompress} />


          <div style={{ height: 'auto', paddingLeft: "0.5rem" }}>

            <div style={{ width: "180px" }}>

              <p className="textSubFunctionlitie">{name}</p>
            </div>

            <div style={{ display: "flex", width: "220px", height: "0.5rem" }}>
              <p className="textValueFunction">{String(develop_time) == 1 ? `${develop_time} dia` : `${develop_time} dias`}</p>
              <p className="textDevelopFunction">{price != undefined ? Number(price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : <></>}</p>

            </div>

          </div>

          <div style={{ cursor: "pointer", marginLeft: "-60px" }} onClick={() => { setShowComponent(true); showImage(id, description);getItemsChecked(id) }}>

        <svg width="30" height="30" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="23" height="23" rx="4.5" fill="white" stroke="#D7D7D7" />
          <g clip-path="url(#clip0_2414_2488)">
            <path d="M19.5442 11.3867C18.5748 9.80793 16.3698 7.15918 12.4998 7.15918C8.62985 7.15918 6.42485 9.80793 5.45547 11.3867C5.1558 11.8714 4.99707 12.43 4.99707 12.9998C4.99707 13.5697 5.1558 14.1282 5.45547 14.6129C6.42485 16.1917 8.62985 18.8404 12.4998 18.8404C16.3698 18.8404 18.5748 16.1917 19.5442 14.6129C19.8439 14.1282 20.0026 13.5697 20.0026 12.9998C20.0026 12.43 19.8439 11.8714 19.5442 11.3867ZM18.4786 13.9586C17.6461 15.3123 15.7617 17.5904 12.4998 17.5904C9.23797 17.5904 7.3536 15.3123 6.5211 13.9586C6.34306 13.6705 6.24876 13.3385 6.24876 12.9998C6.24876 12.6611 6.34306 12.3292 6.5211 12.0411C7.3536 10.6873 9.23797 8.40918 12.4998 8.40918C15.7617 8.40918 17.6461 10.6848 18.4786 12.0411C18.6566 12.3292 18.7509 12.6611 18.7509 12.9998C18.7509 13.3385 18.6566 13.6705 18.4786 13.9586Z" fill="black" />
            <path d="M12.5 9.875C11.8819 9.875 11.2777 10.0583 10.7638 10.4017C10.2499 10.745 9.8494 11.2331 9.61288 11.8041C9.37635 12.3751 9.31447 13.0035 9.43505 13.6096C9.55563 14.2158 9.85325 14.7727 10.2903 15.2097C10.7273 15.6467 11.2842 15.9444 11.8903 16.0649C12.4965 16.1855 13.1249 16.1236 13.6959 15.8871C14.2669 15.6506 14.755 15.25 15.0983 14.7361C15.4417 14.2222 15.625 13.6181 15.625 13C15.624 12.1715 15.2944 11.3772 14.7086 10.7914C14.1228 10.2056 13.3285 9.87599 12.5 9.875ZM12.5 14.875C12.1292 14.875 11.7666 14.765 11.4583 14.559C11.15 14.353 10.9096 14.0601 10.7677 13.7175C10.6258 13.3749 10.5887 12.9979 10.661 12.6342C10.7334 12.2705 10.912 11.9364 11.1742 11.6742C11.4364 11.4119 11.7705 11.2334 12.1342 11.161C12.4979 11.0887 12.8749 11.1258 13.2175 11.2677C13.5601 11.4096 13.853 11.65 14.059 11.9583C14.265 12.2666 14.375 12.6292 14.375 13C14.375 13.4973 14.1775 13.9742 13.8258 14.3258C13.4742 14.6774 12.9973 14.875 12.5 14.875Z" fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_2414_2488">
              <rect width="15" height="15" fill="white" transform="translate(5 5.5)" />
            </clipPath>
          </defs>
        </svg>
        </div>


          <img style={{width:"30px",marginRight:"5px"}} src={select ? trashIcon : addIconContent} onClick={() => {onAddedFeature(id, category,name,description)}} />


        </div>
      </div>
    </div>


  )


}

export default SearchSubComponent